"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var manage_public_report_modal_html_1 = __importDefault(require("./manage-public-report-modal.html"));
require("./manage-public-report.less");
(function (module) {
    'use strict';
    module.factory('prManagePublicReportModal', [
        '$rootScope',
        'qstrap.modal',
        function ($rootScope, modal) {
            function show(source) {
                var scope = $rootScope.$new();
                scope.source = source;
                return modal({
                    show: true,
                    scope: scope,
                    controller: 'prManagePublicReportController',
                    title: '<span translate>MANAGE_PUBLIC_REPORT</span>',
                    contentTemplate: manage_public_report_modal_html_1.default,
                    buttons: [
                        '<button class="btn btn-success" ng-click="($ctrl.publicHash || !$ctrl.isPublic) && close(); $ctrl.save()" ' +
                            'ng-disabled="$ctrl.disableSaveButton()" ' +
                            'qstrap.spin spin-cover="hide" spin-if="$ctrl.updatesPending">' +
                            '<span translate>SAVE</span></button>',
                        '<button class="btn btn" ng-click="close()" ' +
                            'qstrap.spin spin-cover="hide" spin-if="$ctrl.updatesPending">' +
                            '<span translate>CANCEL</span></button>'
                    ]
                });
            }
            return {
                show: show
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
